

    <app-application-details [application]="application"></app-application-details>
   




    <app-application-supporting-docs [application]="application" [isStudent]="true"></app-application-supporting-docs>
   
    <app-application-ftp [application]="application"></app-application-ftp>
   

